import Mutations from '../../odata/mutations';

export default { ...new Mutations('estimation'), ...new Mutations('estimations') };
